import gql from 'graphql-tag';

export const copyClaims = gql`
  mutation copyClaims($sourceRole: String, $destinationRole: String) {
    copyClaims(sourceRole: $sourceRole, destinationRole: $destinationRole) {
      id
      name
      claims {
        id
        name
      }
    }
  }
`;
